export const DATAFEED = {
    "h": [
        5,
        5,
        15,
        20
    ],
    "v": [
        5,
        5,
        20,
        1
    ],
    "l": [
        5,
        5,
        10,
        20
    ],
    "o": [
        5,
        5,
        15,
        20
    ],
    "c": [
        5,
        5,
        10,
        20
    ],
    "t": [
        1721381741,
        1721382285,
        1721382368,
        1721846765
    ],
    "s": "ok"
};